<template>
    <div id="capture">
        <div class="columns">
            <div class='column is-6 is-offset-3'>
                <p>&nbsp;</p>
                <form>
                    <div class='column is-horizontal-center top-logo'>
                          <figure class='image'>
                            <img src="../../assets/images/excel-logo-full.png">
                        </figure>
                    </div>
                    <div v-if="jobNotAvailable">
                        <div class="password-reset" style="margin-bottom: 25px;">
                            <p style="margin-bottom: 10px;"><img src="../../assets/images/caution.png"/></p>
                            <p style="font-size: 16px; font-weight: bold;">Job Filled</p>
                            <p style="font-size: 16px;">
                                Thank you for your interest.
                            </p>
                        </div>
                    </div>
                    <div v-if="captureSuccess">
                        <div class="password-reset" style="margin-bottom: 25px;">
                            <!-- <div v-if="vendorAvailable"> -->
                            <div>
                                <p style="margin-bottom: 10px;"><img width="35px" height="35px" src="../../assets/images/available.png"/></p>
                                <p style="font-size: 16px; font-weight: bold;">Status Submitted</p>
                                <p v-if="formData[0].request_status_id == 15 || formData[0].request_status_id == 16 || formData[0].request_status_id == 17" style="font-size: 16px;">You're <span v-html="getStatus(availabilityData.is_avail)"></span> for this job.
                                </p>
                                <p v-else style="font-size: 16px;">
                                This job has been filled.
                                </p>
                                <p v-if="availabilityData.is_avail == 1" style="font-size: 16px;">
                                    Thank you for your response. Please be advised that submitting your availability does not mean you have an assignment yet. 
                                    <br/><br/>
                                    Our clients reach out to multiple language companies.  We will let our client know that you are available to take this job.  Once they confirm with us that this assignment is still available, we will secure your services - by emailing you a Purchase Order (PO).
                                    <br/><br/>
                                    Until then, you are free to contract with other companies for assignments.  
                                    <br/><br/>
                                    Thank you again for submitting your availability.
                                </p>
                            </div>
                            <!-- <div v-else-if="vendorBooked">
                                <p style="margin-bottom: 10px;"><img width="35px" height="35px" src="../../assets/images/booked.png"/></p>
                                <p style="font-size: 16px; font-weight: bold;">Availability Submitted</p>
                                <br/>
                                <p style="font-size: 16px;">
                                    Thank you! We'll contact you in the future with other opportunities.
                                </p>
                            </div>
                            <div v-else>
                                <p style="margin-bottom: 10px;"><img width="35px" height="35px" src="../../assets/images/success.png"/></p>
                                <p style="font-size: 16px; font-weight: bold;">Availability Submitted</p>
                                <br/>
                                <p style="font-size: 16px;">
                                    We've received your submission. Thank you! <br/>You've indicated that you're <span v-html="getStatus(availabilityData.is_avail)"></span> for this job.
                                </p>
                            </div> -->
                        </div>

                        <div v-if="formData[0].job_type_id === 2" class="password-reset" style="margin-bottom: 25px;">
                            <div class="details gray-bg">
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Due Date</label>
                                                <div class='formfield'>
                                                    {{formData[0].vendor_due_date}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Due Time</label>
                                                <div class='formfield'>
                                                    {{formData[0].vendor_due_time}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-12">
                                                <label>Job Type</label>
                                                <div class='formfield'>
                                                    {{ jobTypeFilter(formData[0].job_type_id) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Source Language</label>
                                                <div class='formfield'>
                                                    {{formData[0].source_language}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Target Language</label>
                                                <div class='formfield'>
                                                    {{formData[0].target_language}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Number of Documents</label>
                                                <div class='formfield'>
                                                    {{formData[0].num_of_document}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Total Word Count</label>
                                                <div class='formfield'>
                                                    {{formData[0].word_count}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="formData[0].job_type_id !== 2" class="password-reset" style="margin-bottom: 25px;">
                            <div class="details gray-bg">
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Service Date</label>
                                                <div class='formfield'>
                                                    {{formData[0].service_date}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Service Time</label>
                                                <div class='formfield'>
                                                    {{formData[0].service_time}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Description</label>
                                                <div class='formfield'>
                                                    {{formData[0].service_description}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Location</label>
                                                <div v-if="formData[0].job_type_id == 1" class='formfield'>
                                                    {{ getCityZip(formData[0].location_name) }}
                                                </div>
                                                <div v-else class='formfield'>
                                                    {{ jobTypeFilter(formData[0].job_type_id) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-12">
                                                <label>Language</label>
                                                <div class='formfield'>
                                                    {{formData[0].target_language}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="captureSuccess && vendorBooked">
                        <div class="password-reset" style="margin-bottom: 25px;">
                        </div>
                    </div>
                    <div v-if="captureFailed">
                        <div class="password-reset" style="margin-bottom: 25px;">
                            <p style="margin-bottom: 10px;"><img src="../../assets/images/error.png"/></p>
                            <p style="font-size: 16px; font-weight: bold;">Save Failed</p>
                            <br/>
                            <p style="font-size: 16px;">
                                The server was unable to process your request. Please contact Excel for further assistance.
                            </p>
                        </div>
                    </div>
                    <div v-if="jobNotFound">
                        <div class="password-reset" style="margin-bottom: 25px;">
                            <p style="margin-bottom: 10px;"><img src="../../assets/images/error.png"/></p>
                            <p style="font-size: 16px; font-weight: bold;">Job Not Found</p>
                            <br/>
                            <p style="font-size: 16px;">
                                The server cannot locate this job, please use the link from text or email.
                            </p>
                        </div>
                    </div>
                    <div v-if="jobAvailable" class="password-reset" style="margin-bottom: 25px;">
                        <p style="font-size: 16px; font-weight: bold;">
                            Are you available for this job?
                        </p>
                    </div>

                    <div v-if="!jobNotFound">
                        <div v-if="formData[0].job_type_id === 2" class="password-reset" style="margin-bottom: 25px;">
                            <div class="details gray-bg">
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Due Date</label>
                                                <div class='formfield'>
                                                    {{formData[0].vendor_due_date}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Due Time</label>
                                                <div class='formfield'>
                                                    {{formData[0].vendor_due_time}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-12">
                                                <label>Job Type</label>
                                                <div class='formfield'>
                                                    {{ jobTypeFilter(formData[0].job_type_id) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Source Language</label>
                                                <div class='formfield'>
                                                    {{formData[0].source_language}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Target Language</label>
                                                <div class='formfield'>
                                                    {{formData[0].target_language}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Number of Documents</label>
                                                <div class='formfield'>
                                                    {{formData[0].num_of_document}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Total Word Count</label>
                                                <div class='formfield'>
                                                    {{formData[0].word_count}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="formData[0].job_type_id !== 2" class="password-reset" style="margin-bottom: 25px;">
                            <div class="details gray-bg">
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Service Date</label>
                                                <div class='formfield'>
                                                    {{formData[0].service_date}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Service Time</label>
                                                <div class='formfield'>
                                                    {{formData[0].service_time}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field padded-bottom-border">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-6">
                                                <label>Description</label>
                                                <div class='formfield'>
                                                    {{formData[0].service_description}}
                                                </div>
                                            </div>
                                            <div class="column is-6">
                                                <label>Location</label>
                                                <div v-if="formData[0].job_type_id == 1" class='formfield'>
                                                    {{ getCityZip(formData[0].location_name) }}
                                                </div>
                                                <div v-else class='formfield'>
                                                    {{ jobTypeFilter(formData[0].job_type_id) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <div class="columns">
                                            <div class="column is-12">
                                                <label>Language</label>
                                                <div class='formfield'>
                                                    {{formData[0].target_language}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="jobAvailable" class="password-reset" style="margin-bottom: 25px;">
                        <ul class="center-button">
                            <li>
                                <span v-on:click="submit('Yes')" style="width: 100px;" class='button is-small is-link'>Yes</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                <span v-on:click="submit('No')" style="width: 100px;" class='button is-small is-danger'>No</span>
                            </li>
                        </ul>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      password: "",
      confirmPassword: "",
      passwordMatch: false,
      passwordErr: false,
      confirmPasswordErr: false,
      canSavePassword: false,
      token: ""
    };
  },

  computed: {
    ...mapState("vendorAvailability", {
      isLoading: state => state.isLoading,
      showTokenExpiredMessage: state => state.showTokenExpiredMessage,
      vendorAvailable: state => state.vendorAvailable,
      vendorBooked: state => state.vendorBooked,
      availabilityData: state => state.availabilityData
    }),

    ...mapGetters("vendorAvailability", {
      jobNotAvailable: "checkJobNotAvailable",
      jobNotFound: "checkJobNotFound",
      jobAvailable: "checkJobAvailable",
      captureSuccess: "checkCaptureSuccess",
      captureFailed: "checkCaptureFailed",
      formData: "getFormData"
    })
  },

  methods: {
    getCityZip: function(value) {
      if (!value) return "";
      value = value.split(",");
      if (value.length == 2) {
        return value[value.length - 1];
      } else {
        return value[value.length - 2] + ", " + value[value.length - 1];
      }
    },

    jobTypeFilter: function(value) {
      switch(value){
          case 1:
              return 'In-Person';
              break;
          case 2:
              return 'Translation';
              break;
          case 3:
              return 'Telephonic';
              break;
          case 4:
              return 'VRI';
              break;
          default:
              return '';
              break;
      }
    },

    getStatus(value){
      if(value){
        return '<span style="font-weight:bold; color: green">Available</span>';
      } else {
        return '<span style="font-weight:bold; color: red">Not Available</span>';
      }

    },
    submit(val) {
      // this will save the url of client
      VueStore.dispatch("vendorAvailability/saveData", val);
    },

    checkValue(val) {},

    returnToLogin() {
      window.location.href = "/login";
    },

    clearErrorMsgs() {},

    fetchData() {
      // this will save the url of client
      VueStore.dispatch("global/getBaseURL");
    },

    prcoessURL() {
      var url_string = window.location.href;
      var url = new URL(url_string);
      var token = url.searchParams.get("token");
      var id = url.searchParams.get("id");
      var confirm_type_id = url.searchParams.get("confirm_type_id");

      if (confirm_type_id !== null) {
        VueStore.dispatch("vendorAvailability/setVariable", {
          key: "confirm_type_id",
          value: confirm_type_id
        });
      }

      if (token !== null && id !== null && confirm_type_id !== null) {
        var data = {
          token: token,
          id: id
        };

        // we'll save token for later usage
        this.token = token;

        // delay so auth store is loaded.
        setTimeout(function() {
          VueStore.dispatch("vendorAvailability/checkToken", data);
        }, 500);
      } else {
        // show job not available
        VueStore.dispatch("vendorAvailability/toggleBooleanState", {
          key: "jobNotFound",
          bool: true
        });
      }
    }
  },

  mounted() {
    this.fetchData();
    this.prcoessURL();
    // retrive environment variables and stored in vuex.
    VueStore.dispatch("auth/setVariables");
  }
};
</script>

<style>
body {
  overflow-y: auto;
  position: relative;
}

.center-button {
  display: flex;
  justify-content: center;
}
</style>
